import { render, staticRenderFns } from "./BecauseYouLikedModule.vue?vue&type=template&id=7b5fbad6&scoped=true"
import script from "./BecauseYouLikedModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./BecauseYouLikedModule.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BecauseYouLikedModule.vue?vue&type=style&index=0&id=7b5fbad6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5fbad6",
  null
  
)

export default component.exports